import { create } from 'zustand'

export const useGameStore = create((set, get) => ({
  // Partie courante
  game:    null,
  kart:    null,
  players: [],
  question: null,

  // Actions
  setGame:     (game)     => set({ game }),
  setKart:     (kart)     => set({ kart }),
  setPlayers:  (players)  => set({ players }),
  setQuestion: (question) => set({ question }),

  reset: () => set({ game: null, kart: null, players: [], question: null }),
}))
